import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row, HelpBlock } from 'react-bootstrap';
import { Input, DateTimeInput, FormActions, Select } from '../../../common/components/formControls';
import TermsDropdownList from '../../terms/DropdownList';
import CentersDropdownList from '../../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import validators from '../../../common/services/validators';
import utils from '../../../common/services/utils';
import ui from '../../../common/services/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, onSubmit, reset, loading, onTermSelected, grades, t, reportOptions }) => {
	const handleReset = () => {
		reset();
		setTimeout(() => handleSubmit());
	};
	return (
		<Panel>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit(values => onSubmit({ ...values, isExport: false }))}>
					<Row>
						<Col sm={6}>
							<CentersDropdownList render='field' name='centerId' label={reportOptions.centerLabel} required={reportOptions.requiredCenter} validate={reportOptions.requiredCenter ? validators.required : []} />
						</Col>
						{reportOptions.filterByTerm &&
							<Col sm={6}>
								<TermsDropdownList render='field' defaultSelection='active' name='termId' onChange={onTermSelected} hideEmptyOption={false} label={reportOptions.termLabel} validate={validators.required} />
							</Col>
						}
						{reportOptions.filterByPeriod &&
							<Col sm={6}>
								<Col sm={6}>
									<Field name='startDate' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodFrom()} placeholder={t('Common_From')} label={t('ReportChildren_Period')} />
								</Col>
								<Col sm={6}>
									<Field name='endDate' component={DateTimeInput} showTime={false} defaultCurrentDate={utils.defaultDatePeriodTo()} placeholder={t('Common_To')} label='&nbsp;' />
								</Col>
							</Col>
						}
					</Row>
					{reportOptions.filterByGrade &&
						<Row>
							<Col sm={6}>
								<Select name='gradeId' data={grades} label={t('ReportChildren_Grade')} />
							</Col>
							{reportOptions.showLessonInfo && <Col sm={6}>
								<Select name='weekDay' data={Object.keys(ui.days).filter(key => Number(key) > 0).map(key => ({ id: key, displayName: t(ui.days[key]) }))} label={t('ReportChildren_WeekDay')} />
							</Col>}
							{reportOptions.showComparisonTerm && <Col sm={6}>
								<TermsDropdownList render='field' name='comparisonTermId' hideEmptyOption={false} label={t('ReportChildren_ComparisonTerm')} />
							</Col>}
						</Row>
					}
					<Row>
						{reportOptions.showIsAttended && <Col sm={6}>
							<Field name='isAttended' component={Input} componentClass='select' label={t('ReportChildren_IsAttended')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>}
						{reportOptions.showEnrolled && <Col sm={6}>
							<Field name='enrolled' component={Input} componentClass='select' label={t('ReportChildren_Enrolled')}>
								<option value={''}>{t('Common_All')}</option>
								<option value={true}>{t('Common_Yes')}</option>
								<option value={false}>{t('Common_No')}</option>
							</Field>
						</Col>}
					</Row>
					<FormActions>
						<Button onClick={handleSubmit(values => onSubmit({ ...values, isExport: false }))} disabled={loading} bsStyle='primary'>{t('Common_Filter')}</Button>
						<Button onClick={handleSubmit(values => onSubmit({ ...values, isExport: true }))} disabled={loading} bsStyle='warning'>{t('Common_ExportToExcel')}</Button>
						<Button disabled={loading} onClick={handleReset}>{t('Common_Reset')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'reportChildrenDetailsFilter' })(withTranslation()(Filter));